import React, { CSSProperties } from 'react';

export enum LineOfCreditStepPage {
  ONBOARDING,
  FORM,
}

export interface OnboardingCardDetails {
  imageAltText: string;
  imageUrl: string;
  primaryText: string;
  secondaryText: string;
}

export function getPrimaryButtonText(
  isOnboardingPage: boolean,
  isUpdatingStep: boolean
): JSX.Element {
  if (isOnboardingPage) {
    return <span>Create meal credit</span>;
  }

  if (isUpdatingStep) {
    return <span>Update</span>;
  }

  return <span>Next</span>;
}

export function getOnboardingCardColumnStyle(
  isMobile: boolean,
  isTablet: boolean
): CSSProperties {
  if (isMobile) {
    return {};
  }

  if (isTablet) {
    return { padding: '0 16px' };
  }

  return { padding: '0 32px' };
}
